import React from "react";
import {Button} from "@material-ui/core";
import { useStyles } from "./../styles";
import { get } from "lodash";
import UserProfileWidget from "../../widgets/UserProfileWidget";

const ProfileMenu = ({ menuId, handleProfileMenuOpen, userDetails }) => {
  const classes = useStyles();

  return (
    <div>
      <Button
        aria-label="account of current user"
        aria-controls={menuId}
        aria-haspopup="true"
        onClick={handleProfileMenuOpen}
        color="inherit"
        className={classes.avatarBtn}
      >
        <UserProfileWidget
          firstName={get(userDetails, "firstName", "")}
          lastName={get(userDetails, "lastName", "")}
          url={get(userDetails, "profileImage.fileName", "")}
        />
      </Button>
    </div>
  );
};

export default ProfileMenu;
